<template lang="html">
  <div class="footer-top">
    <b-container>
      <b-row>
      <b-col md="12" >
        <div class="mt-5">
          <h2 class="mt-3">MOVING FORWARD</h2>
          <p class="mt-3">At the moment we are in the prototyping and testing phase of our development cycle and we hope that the first iteration of both the device and the app will be available within the next few months.</p>
          <SignupForm />
        </div>
        <div class="mt-5">
          <p>If you have any suggestions or you want to tell us your story, we’d love to hear from you!</p>
          <p class="mt-2"> <a href="mailto:connect@happyg.care">Get in touch</a> </p>
        </div>
        <div class="mt-5">
          <p>Help us spread the word:</p>
          <p class="mt-2">
            <a href="https://www.instagram.com/myhappyg/" target="_blank">Instagram</a>
            <span class="ml-5">
              <a href="https://www.instagram.com/explore/tags/myhappyg/" target="_blank" >#myhappyg</a>
            </span></p>
        </div>
      </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SignupForm from '../Forms/SignupForm'
export default {
  components: {
    SignupForm,
  },
}
</script>

<style lang="scss" scoped>
  a {
    text-decoration: underline;
  }
</style>
